import { api } from "./config/axios";

import {
  CallPayload,
  PostsResponse,
  ArticleResponse,
  SendCodePayload,
  LoginUSerPayload,
  SendCodeResponse,
  HandbookResponse,
  VerifyCodePayload,
  ResendCodePayload,
  HandbooksResponse,
  VerifyCodeResponse,
  ResendCodeResponse,
  MetaModalsResponse,
  RegisterUserPayload,
  RegisterUserResponse,
  ChangePasswordPayload,
  RegisterUserPayloadOld,
  VerifyAuthHashResponse,
  CheckUserExistsPayload,
  GetCurrentUserResponse,
  VerifyUserHashResponse,
  CheckUserExistsResponse,
  RandomHandbooksResponse,
  GetProCalculationResponse,
  GetProCalculationChartsResponse,
} from "./types";

import { normalizePresentation } from "./normalizers";

// ------------------- AUTH API NEW ------------------- //
//TODO add response types later//

export const loginUser = (data: LoginUSerPayload): Promise<any> =>
  api.common.post("/api/v1/auth/login", data);

export const registerUser = (data: RegisterUserPayload): Promise<any> =>
  api.common.post("/api/v1/auth/register", data);

export const passwordForgot = (data: { email: string }): Promise<any> =>
  api.common.post("/api/v1/auth/forgot-password", data);

export const checkHashExpiration = (data: { hash: string }): Promise<any> =>
  api.common.post("/api/v1/auth/check-hash-expiration", data);

export const resetPassword = (data: {
  hash: string;
  password: string;
}): Promise<any> => api.common.post("/api/v1/auth/verify-password", data);

export const verifyHash = (data: { hash: string }): Promise<any> =>
  api.common.post("/api/v1/auth/verify-hash", data);

export const refreshToken = (data: {
  refreshToken: string;
}): Promise<{ token: string; refreshToken: string }> =>
  api.common.post("/api/v1/auth/refresh", data);

// ------------------- AUTH API NEW ------------------- //

// ------------------- AUTH API ------------------- //
export const checkUserExists = (
  data: CheckUserExistsPayload
): Promise<CheckUserExistsResponse> =>
  api.common.post("/api/v1/auth/check/user-exists", data);

export const registerUserOld = (
  data: RegisterUserPayloadOld
): Promise<RegisterUserResponse> =>
  api.common.post("/api/v1/auth/register", data);

export const getCurrentUser = (): Promise<GetCurrentUserResponse> =>
  api.common.get("/api/v1/auth/me");

export const sendCode = (data: SendCodePayload): Promise<SendCodeResponse> =>
  api.common.post("/api/v1/auth/send-code", data);

export const changePassword = (data: ChangePasswordPayload): Promise<any> =>
  api.common.post("/api/v1/auth/change-password", data);

export const verifyCode = (
  data: VerifyCodePayload
): Promise<VerifyCodeResponse> =>
  api.common.post("/api/v1/auth/verify-code", data);

export const resendCode = (
  data: ResendCodePayload
): Promise<ResendCodeResponse> =>
  api.common.post("/api/v1/auth/resend-code", data);

export const verifyAuthHash = (hash: string): Promise<VerifyAuthHashResponse> =>
  api.common.post(`/api/v1/auth/verify/${hash}`);

export const verifyUserHash = (hash: string): Promise<VerifyUserHashResponse> =>
  api.common.post(`/api/v1/auth/verify/user/${hash}`);

export const logout = (): Promise<any> =>
  api.common.post(`/api/v1/auth/logout`);
// ------------------- AUTH API ------------------- //

// ------------------- USER API ------------------- //
export const getUsers = (): Promise<any> => api.common.get("/api/v1/users");

export const getUserById = (userId: string): Promise<any> =>
  api.common.get(`/api/v1/users/${userId}`);

export const updateUserById = (userId, data): Promise<any> =>
  api.common.put(`/api/v1/users/${userId}`, data);

export const getUserListingTypes = (userId: string): Promise<any> =>
  api.common.get(`/api/v1/users/${userId}/listing-types`);

export const getDefaultUserListingTypes = (): Promise<any> =>
  api.common.get(`/api/v1/users/default/listing-types`);

// ------------------- USER API ------------------- //

// ------------------- ORGANIZATION-EMPLOYEES API ------------------- //
export const getOperatorById = (operatorId: string): Promise<any> =>
  api.common.get(`/api/v1/users/${operatorId}`);
// ------------------- ORGANIZATION-EMPLOYEES API ------------------- //

// ------------------- BOOKING API ------------------- //
export const getBookingsByUserId = (): Promise<any> =>
  api.common.get(`/api/v1/bookings`);

export const getBookingsByOperatorId = (id): Promise<any> =>
  api.common.get(`/api/v1/bookings/operators/${id}`);

export const getBookingsByOperatorIdRaw = (id): Promise<any> =>
  api.common.get(`/api/v1/bookings/operators/${id}/raw`);

export const createBooking = (data: any): Promise<any> =>
  api.common.post("/api/v1/bookings", data);

export const updateBookingById = (bookingId: string, data: any): Promise<any> =>
  api.common.put(`/api/v1/bookings/${bookingId}`, data);

export const deleteBookingById = (bookingId: string): Promise<any> =>
  api.common.delete(`/api/v1/bookings/${bookingId}`);

export const getBookingSlots = (postSlug?: string): Promise<any> =>
  api.common.get(
    `/api/v1/bookings/slots${postSlug ? `?postSlug=${postSlug}` : ""}`
  );

export const createCallBooking = (data: CallPayload): Promise<any> =>
  api.common.post("/api/v1/bookings", data);

export const getPublicBookingByHash = (hash: string): Promise<any> =>
  api.common.get(`/api/v1/bookings/guest?hash=${hash}`);

export const updatePublicBookingByHash = (data: any): Promise<any> =>
  api.common.put(`/api/v1/bookings/guest`, data);

export const deletePublicBookingByHash = (hash: string): Promise<any> =>
  api.common.delete(`/api/v1/bookings/guest?hash=${hash}`);

export const getMyBookings = ({ queryParams }): Promise<any> =>
  api.common.get(
    `/api/v1/auth/me/bookings?${new URLSearchParams(queryParams).toString()}`
  );

export const getMyCalls = ({ queryParams }): Promise<any> =>
  api.common.get(
    `/api/v1/auth/me/calls?${new URLSearchParams(queryParams).toString()}`
  );

// ------------------- BOOKING API ------------------- //

// ------------------- SESSION API ------------------- //

export const createSession = (data: any): Promise<any> =>
  api.common.post("/api/v1/sessions", data);

export const getSessions = (): Promise<any> =>
  api.common.get(`/ api / v1 / sessions`);

export const getSessionsByUserId = (userId: string): Promise<any> =>
  api.common.get(`/ api / v1 / sessions / users / ${userId} `);

export const getSessionById = (sessionId: string): Promise<any> =>
  api.common.get(`/ api / v1 / sessions / ${sessionId} `);

export const updateSessionById = (sessionId: string, data: any): Promise<any> =>
  api.common.put(`/ api / v1 / sessions / ${sessionId} `, data);
// ------------------- SESSION API ------------------- //

// ------------------- COURSE API ------------------- //
export const getCourses = (): Promise<any> =>
  api.common.get(`/ api / v1 / courses`);

export const getCourse = (slug: string): Promise<any> =>
  api.common.get(`/ api / v1 / courses / users / slugs / ${slug} `);
// ------------------- COURSE API ------------------- //

// ------------------- COURSE SESSION API ------------------- //

export const getCourseLessonById = (lessonId: string) =>
  api.common.get(`/ api / v1 / course - lessons / users / ${lessonId} `);

export const completeCourseLesson = (courseId: string, data: any) =>
  api.common.post(
    `/ api / v1 / course - sessions / courses / ${courseId}/complete`,
    data
  );

export const completeCourseLessonStep = (courseId: string, data: any) =>
  api.common.post(
    `/api/v1/course-sessions/courses/${courseId}/complete/step`,
    data
  );

export const restartCourseLessonById = (
  courseId: string,
  lessonId: string
): Promise<any> =>
  api.common.post(
    `/api/v1/course-sessions/courses/${courseId}/restart/lesson`,
    {
      lessonId,
    }
  );
// ------------------- COURSE SESSION API ------------------- //

// ------------------- PRESENTATION API ------------------- //
export const getPresentations = (): Promise<any[]> =>
  api.common.get(`/api/v1/presentations`);

export const getPresentationsList = (): Promise<any[]> =>
  api.common.get(`/api/v1/presentations/list`);

export const getPresentationById = (presentationId: string): Promise<any> =>
  api.common
    .get(`/api/v1/presentations/${presentationId}`)
    .then((response) => normalizePresentation(response));

export const processVoiceRecognition = (
  presentationId: string,
  slideId: string,
  stepId: string,
  data: any
): Promise<any> =>
  api.common.post(
    `/api/v1/presentations/${presentationId}/slides/${slideId}/video-steps/${stepId}/voice-recognition`,
    data,
    {
      headers: { "Content-Type": "multipart/form-data" },
    }
  );
// ------------------- PRESENTATION API ------------------- //

// ------------------- AVATAR API ------------------- //
export const getAvatars = (): Promise<any> => api.common.get("/api/v1/avatars");

// ------------------- AVATAR API ------------------- //

// ------------------- META API ------------------- //
export const getMeta = (): Promise<any> => api.common.get("/api/v1/meta");

export const uploadFileToMeta = (_, data: any): Promise<any> =>
  api.common.post(`/api/v1/meta/upload-file`, data, {
    headers: { "Content-Type": "multipart/form-data" },
  });

export const removeFileFromMeta = (data: any): Promise<any> =>
  api.common.delete(`/api/v1/meta/remove-file`, data);
// ------------------- META API ------------------- //

// ------------------- UPLOAD API ------------------- //

export const getPresignedUrl = (
  fileName: string,
  contentType: string
): Promise<any> =>
  api.common.get(
    `/api/v1/upload/presigned-url?fileName=${fileName}&contentType=${contentType}`
  );

export const makeFilePublic = (filePath: string): Promise<any> =>
  api.common.post(`/api/v1/upload/make-public?fileName=${filePath}`);
// ------------------- UPLOAD API ------------------- //

// ------------------- USER SETTINGS API ------------------- //

export const getUserSettingsByUserId = (userId: string) =>
  api.common.get(`/api/v1/user-settings/${userId}`);

export const getCalculationValuesByUserId = (userId: string) =>
  api.common.get(`/api/v1/user-settings/${userId}/calculation-values`);

export const updateCalculationValuesByUserId = (userId: string, data: any) =>
  api.common.put(`/api/v1/user-settings/${userId}/calculation-values`, data);

// ------------------- USER SETTINGS API ------------------- //

// ------------------- POSTS API ------------------- //

export const getFiltersMeta = (listingType: string): Promise<any> =>
  api.common.get(
    `/api/v1/users/posts/filters${
      listingType ? `?listingType=${listingType}` : ""
    }`
  );

export const getPosts = ({
  userId,
  queryParams,
}: any): Promise<PostsResponse> =>
  api.common.get(
    `/api/v1/users/${userId}/posts/?${new URLSearchParams(
      queryParams
    ).toString()}`
  );

export const getDefaultPosts = ({ queryParams }: any): Promise<PostsResponse> =>
  api.common.get(
    `/api/v1/users/default-posts?${new URLSearchParams(queryParams).toString()}`
  );

export const getPost = ({
  userId,
  slug,
}: {
  userId: string;
  slug: string;
}): Promise<PostsResponse> =>
  api.common.get(`/api/v1/users/${userId}/posts/slugs/${slug}`);

export const updatePost = ({
  userId,
  postSlug,
  data,
}: {
  userId: string;
  postSlug: string;
  data: any;
}): Promise<any> =>
  api.common.put(`/api/v1/users/${userId}/posts/slugs/${postSlug}`, data);

export const getDefaultPost = ({
  slug,
}: {
  slug: string;
}): Promise<PostsResponse> =>
  api.common.get(`/api/v1/users/default-posts/slugs/${slug}`);

export const getRandomPosts = ({
  userId,
  queryParams,
}: {
  userId?: string;
  queryParams?: any;
}): Promise<any> =>
  api.common.get(
    `/api/v1/users/${userId}/random-posts?${new URLSearchParams(
      queryParams
    ).toString()}`
  );

export const getDefaultRandomPosts = ({
  queryParams,
}: {
  queryParams?: any;
}): Promise<any> =>
  api.common.get(
    `/api/v1/users/random-posts/default?${new URLSearchParams(
      queryParams
    ).toString()}`
  );

export const updatePosts = ({
  userId,
  queryParams,
  data,
}: {
  userId: string;
  queryParams: any;
  data: any;
}): Promise<PostsResponse> =>
  api.common.put(
    `/api/v1/users/${userId}/posts/?${new URLSearchParams(
      queryParams
    ).toString()}`,
    data
  );

export const subscribeToNewPosts = (data: { email: string }): Promise<any> =>
  api.common.post(`/api/v1/users/subscribe-new-posts`, data);

export const getPostsStatus = (): Promise<any> =>
  api.common.get(`/api/v1/posts/check/status`);

// ------------------- POSTS API ------------------- //

// ------------------- HANDBOOK API ------------------- //

export const getArticlesCategories = (queryParams: any): Promise<any> =>
  api.common.get(
    `/api/v1/article-categories/users?${new URLSearchParams(
      queryParams
    ).toString()}`
  );

export const getHandbooks = (queryParams: any): Promise<HandbooksResponse> =>
  api.common.get(
    `/api/v1/articles/users/all?${new URLSearchParams(queryParams).toString()}`
  );

export const getRandomHandbooks = (
  queryParams
): Promise<RandomHandbooksResponse> =>
  api.common.get(
    `api/v1/articles/users/random?${new URLSearchParams(
      queryParams
    ).toString()}`
  );

export const getHandbook = (slug: string): Promise<HandbookResponse> =>
  api.common.get(`api/v1/articles/slugs/${slug}`);

export const getArticleById = (articleId: string): Promise<ArticleResponse> =>
  api.common.get(`api/v1/articles/${articleId}`);

// ------------------- HANDBOOK API ------------------- //

// ------------------- BLOGS API ------------------- //

export const getBlogs = (queryParams: any): Promise<any> =>
  api.common.get(
    `/api/v1/articles/users/all?${new URLSearchParams(queryParams).toString()}`
  );

export const getRandomBlogs = (queryParams): Promise<any> =>
  api.common.get(
    `api/v1/articles/users/random?${new URLSearchParams(
      queryParams
    ).toString()}`
  );

export const getBlog = (slug: string): Promise<any> =>
  api.common.get(`api/v1/articles/slugs/${slug}`);

// ------------------- BLOGS API ------------------- //

// ------------------- FAQ API ------------------- //

export const getFaq = (queryParams): Promise<any> =>
  api.common.get(
    `/api/v1/articles/users/all?${new URLSearchParams({
      type: "faq",
      pageType: "faq",
      ...queryParams,
    }).toString()}`
  );

export const getFaqUserFeedbacks = (): Promise<any> =>
  api.common.get(`/api/v1/user-settings/user/faq-feedbacks`);

export const updateFaqUserFeedback = (
  questionId: string,
  data: any
): Promise<any> =>
  api.common.put(
    `/api/v1/user-settings/user/faq-feedbacks/${questionId}`,
    data
  );

export const deleteFaqUserFeedback = (questionId: string): Promise<any> =>
  api.common.delete(`/api/v1/user-settings/user/faq-feedbacks/${questionId}`);

// ------------------- FAQ API ------------------- //

// ------------------- DASHBOARD API ------------------- //

export const getOrderSteps = (): Promise<any> =>
  api.common.get(`/api/v1/order-steps/users/`);

export const getCurrentOrder = (): Promise<any> =>
  api.common.get(`/api/v1/orders/current`);

export const makeOrder = (data: {
  operatorId: string;
  date: string;
}): Promise<any> => api.common.post(`/api/v1/bookings/users/order`, data);

export const updateOrder = (data: {
  operatorId: string;
  date: string;
}): Promise<any> => api.common.put(`/api/v1/bookings/users/order`, data);

export const deleteOrder = (): Promise<any> =>
  api.common.delete(`/api/v1/bookings/users/order`);

export const addPostToOrder = (orderId: string, postId: string): Promise<any> =>
  api.common.put(`/api/v1/orders/${orderId}`, { postId: postId });

// ------------------- DASHBOARD API ------------------- //

// ------------------- SUBSCRIPTION API ------------------- //

export const subscribeToBlog = (data: { email: string }): Promise<any> =>
  api.common.post(`/api/v1/users/subscribe-blog`, data);

// ------------------- SUBSCRIPTION API ------------------- //

// ------------------- REVIEWS API ------------------- //

export const createReview = (data: any): Promise<any> =>
  api.common.post("/api/v1/reviews", data);

// ------------------- REVIEWS API ------------------- //

// ------------------- CALCULATOR API ------------------- //
export const checkCalculatorDomain = (): Promise<any> =>
  api.calculator.post(`/api/v1/auth/check/domain`);

export const getCalculationValues = (organizationId: string): Promise<any> =>
  api.calculator.get(
    `/api/v1/calculation/calculation/values${
      organizationId ? `?organizationId=${organizationId}` : ""
    }`
  );

export const updateCalculationValues = (
  valuesId: string,
  data: any
): Promise<any> =>
  api.calculator.put(
    `/api/v1/calculation/calculation/values/${valuesId}`,
    data
  );

export const getBaseCalculation = (data: any): Promise<any> =>
  api.calculator.post(`/api/v1/calculation/calculation/full`, data);

export const getProCalculation = (
  data: any
): Promise<GetProCalculationResponse> =>
  api.calculator.post(`/api/v1/calculation/calculation/pro`, data);

export const getProCalculationCharts = (
  data: any
): Promise<GetProCalculationChartsResponse> =>
  api.calculator.post(`/api/v1/calculation/calculation/charts/pro`, data);

export const getProCalculationDocument = (data: any): Promise<any> =>
  api.calculator.post(`/api/v1/calculation/calculation/pro/document`, data);

export const downloadProCalculationDocument = (data: any): Promise<any> =>
  api.calculator.post(
    `/api/v1/calculation/calculation/pro/download-document`,
    data
  );

export const getCalculatorHistoryById = (id: string): Promise<any> =>
  api.calculator.get(`/api/v1/calculation/calculator-history/${id}`);

export const getCalculatorHistoryByUserId = ({
  userId,
  queryParams,
}): Promise<any> =>
  api.calculator.get(
    `/api/v1/calculation/calculator-history/users/${userId}?${new URLSearchParams(
      queryParams
    ).toString()}`
  );

export const getCalculatorHistoryByOrganizationId = ({
  organizationId,
  queryParams,
}): Promise<any> =>
  api.calculator.get(
    `/api/v1/calculation/calculator-history/organizations/${organizationId}?${new URLSearchParams(
      queryParams
    ).toString()}`
  );

export const getLastCalculatorHistoryByUserId = (
  userId: string
): Promise<any> =>
  api.calculator.get(
    `/api/v1/calculation/calculator-history/users/${userId}/last`
  );
// ------------------- CALCULATOR API ------------------- //

export const getDirectoryByType = (type: string): Promise<any> =>
  api.common.get(`/api/v1/directory/${type}`);

export const getLoans = (): Promise<any> => api.common.get("/api/v1/loans");

export const getProjects = (): Promise<any> =>
  api.common.get("/api/v1/projects");

export const sendContact = (data: any): Promise<any> =>
  api.common.post("/api/v1/users/send-contact", data);

export const subscribeToHandbook = (data: any): Promise<any> =>
  api.common.post("/api/v1/users/subscribe-handbook", data);

export const registerOrgUser = (data: any): Promise<any> =>
  api.common.post("/api/v1/auth/register-org-user", data);

export const getCurrentUserOrganization = (): Promise<any> =>
  api.common.get("/api/v1/auth/me/organization");

export const getOrganizationByDomain = (domain: string): Promise<any> =>
  api.common.get(`/api/v1/organizations/domain/${domain}`);

export const getOrganizationById = (id: string): Promise<any> =>
  api.common.get(`/api/v1/organizations/${id}`);

export const createOrganizationEmployee = (data: any): Promise<any> =>
  api.common.post(`/api/v1/users/operators`, data);

export const updateOrganizationEmployeeById = (
  employeeId: string,
  data: any
): Promise<any> =>
  api.common.put(`/api/v1/users/operators/${employeeId}`, data);

export const createOrganizationTeam = (data: any): Promise<any> =>
  api.common.post(`/api/v1/organization-teams`, data);

export const updateOrganizationTeamById = (
  teamId: string,
  data: any
): Promise<any> => api.common.put(`/api/v1/organization-teams/${teamId}`, data);

// ------------------- INVITATION API ------------------- //

export const createInvitation = (data: any): Promise<any> =>
  api.common.post("/api/v1/invitations", data);

export const getIncomingInvitations = (): Promise<any[]> =>
  api.common.get("/api/v1/invitations/incoming");

export const getOutgoingInvitations = (): Promise<any[]> =>
  api.common.get("/api/v1/invitations/outgoing");

export const getInvitationsByOrganizationId = (
  organizationId: string
): Promise<any> =>
  api.common.get(`/api/v1/invitations/organization/${organizationId}`);

export const getInvitationById = (invitationId: string): Promise<any> =>
  api.common.get(`/api/v1/invitations/${invitationId}`);

export const acceptInvitationByHash = (hash: string): Promise<any> =>
  api.common.put(`/api/v1/invitations/accept-by-hash`, { hash });

export const acceptInvitation = (invitationId: string): Promise<any> =>
  api.common.put(`/api/v1/invitations/${invitationId}/accept`);

export const rejectInvitation = (invitationId: string): Promise<any> =>
  api.common.put(`/api/v1/invitations/${invitationId}/reject`);

export const archiveInvitation = (invitationId: string): Promise<any> =>
  api.common.put(`/api/v1/invitations/${invitationId}/archive`);

export const deleteInvitation = (invitationId: string): Promise<any> =>
  api.common.delete(`/api/v1/invitations/${invitationId}/delete`);

export const resendInvitation = (invitationId: string): Promise<any> =>
  api.common.put(`/api/v1/invitations/${invitationId}/resend`);

export const cancelInvitation = (invitationId: string): Promise<any> =>
  api.common.put(`/api/v1/invitations/${invitationId}/cancel`);

// ------------------- INVITATION API ------------------- //

export const setModalConfig = (
  metaId: string,
  modalKey: string,
  body: Record<string, string | string[]>
): Promise<MetaModalsResponse> =>
  api.common.put(`/api/v1/meta/${metaId}/modals/${modalKey}`, body);

export const removeModalConfig = (
  metaId: string,
  modalKey: string
): Promise<MetaModalsResponse> =>
  api.common.delete(`/api/v1/meta/${metaId}/modals/${modalKey}`);

export const updateOrganizationById = (
  organizationId: string,
  data: any
): Promise<any> =>
  api.common.put(`/api/v1/organizations/${organizationId}`, data);

export const removeOrganizationTeamById = (teamId: string): Promise<any> =>
  api.common.delete(`/api/v1/organization-teams/${teamId}`);

// ------------------- WIDGET API ------------------- //

export const createWidget = (data: any): Promise<any> =>
  api.common.post("/api/v1/organization-widgets", data);

export const deleteWidget = (widgetId: string): Promise<any> =>
  api.common.delete(`/api/v1/organization-widgets/${widgetId}`);

export const updateWidget = (widgetId: string, data: any): Promise<any> =>
  api.common.put(`/api/v1/organization-widgets/${widgetId}`, data);

export const getWidgetsByOrganizationId = (
  organizationId: string
): Promise<any> =>
  api.common.get(`/api/v1/organizations/${organizationId}/widgets`);

export const getWidgetById = (widgetId: string): Promise<any> =>
  api.common.get(`/api/v1/organization-widgets/${widgetId}`);

// ------------------- ORGANIZATION MODALS API ------------------- //

export const createModals = (data: any): Promise<any> =>
  api.common.post("/api/v1/organization-modals", data);

export const deleteModalsById = (modalId: string): Promise<any> =>
  api.common.delete(`/api/v1/organization-modals/${modalId}`);

export const updateModalsById = (modalId: string, data: any): Promise<any> =>
  api.common.put(`/api/v1/organization-modals/${modalId}`, data);

export const getModalsByOrganizationId = (
  organizationId: string
): Promise<any> =>
  api.common.get(`/api/v1/organizations/${organizationId}/modals`);

export const getModalById = (modalId: string): Promise<any> =>
  api.common.get(`/api/v1/organization-modals/${modalId}`);
